<template>
    <kgr-generic-modal
        v-if="showDialog"
        :value="showDialog"
        :headline="tHeadline"
        :width-in-px="600"
        scrollable
        @post-input="closeDialog()"
    >
        <kgr-loading
            v-show="loading"
            inline
        />
        <div v-show="!loading" class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
            <div class="kgr-grid__cell">
                <label class="kgr-checkbox">
                    <input
                        v-model="dogUsabilityPass.levelA"
                        type="checkbox"
                        class="kgr-checkbox__control"
                        style="margin-bottom: 10px;"
                    />
                    <span class="kgr-checkbox__label">{{ tLevelA }}</span>
                </label>
                <label class="kgr-checkbox">
                    <input
                        v-model="dogUsabilityPass.levelB"
                        type="checkbox"
                        class="kgr-checkbox__control"
                        style="margin-bottom: 10px;"
                    />
                    <span class="kgr-checkbox__label">{{ tLevelB }}</span>
                </label>
                <label class="kgr-checkbox">
                    <input
                        v-model="dogUsabilityPass.levelC"
                        type="checkbox"
                        class="kgr-checkbox__control"
                        style="margin-bottom: 10px;"
                    />
                    <span class="kgr-checkbox__label">{{ tLevelC }}</span>
                </label>
                <label class="kgr-checkbox">
                    <input
                        v-model="dogUsabilityPass.levelD"
                        type="checkbox"
                        class="kgr-checkbox__control"
                        style="margin-bottom: 10px;"
                    />
                    <span class="kgr-checkbox__label">{{ tLevelD }}</span>
                </label>
                <label class="kgr-checkbox">
                    <input
                        v-model="dogUsabilityPass.levelE"
                        type="checkbox"
                        class="kgr-checkbox__control"
                        style="margin-bottom: 10px;"
                    />
                    <span class="kgr-checkbox__label">{{ tLevelE }}</span>
                </label>
            </div>
            <div class="kgr-grid__cell">
                <kgr-text-input
                    v-model.trim="dogUsabilityPass.location"
                    :label="tLocation"
                />
                <br />
                <div class="kgr-inputGroup__label">
                    {{ tExhibitionDate }}
                </div>
                <kgr-date-picker
                    v-model="exhibitionDate"
                    @inputIso8601="dogUsabilityPass.exhibitionDate = $event"
                />
            </div>
        </div>
        <template #footer>
            <kgr-button
                class="kgr-col kgr-button--outline float-left"
                @click="closeDialog"
            >
                {{ tCancel }}
            </kgr-button>
            <span :title="tInvalidInput">
                <kgr-button
                    class="kgr-col"
                    :pending="pending"
                    :disabled="!validInput"
                    @click="createPass"
                >
                    {{ tSaveAndClose }}
                </kgr-button>
            </span>
        </template>
    </kgr-generic-modal>
</template>

<script>
import DatePicker from '../common/form/picker/DatePicker.vue';
import DogUsabilityPass from '../../js/dto/DogUsabilityPass.js';
import DogUsabilityPassRepository from '../../js/repository/club/dog/DogUsabilityPassRepository.js';
import GenericModal from '../common/modal/GenericModal.vue';
import KgrButton from '../common/form/button/KgrButton.vue';
import Loading from '../common/Loading.vue';
import TextInput from '../common/form/input/TextInput.vue';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-button': KgrButton,
        'kgr-generic-modal': GenericModal,
        'kgr-loading': Loading,
        'kgr-text-input': TextInput,
    },
    props: {
        dogId: {
            type: String,
            required: true,
        },
        showDialog: {
            type: Boolean,
            required: true,
        },
        defaultLocation: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            pending: false,
            dogUsabilityPass: new DogUsabilityPass(),
            exhibitionDate: null,
        }
    },
    computed: {
        tHeadline () {
            return this.$t('Brauchbarkeitspass erstellen');
        },
        tLevelA() {
            return this.$t('Stufe A');
        },
        tLevelB() {
            return this.$t('Stufe B');
        },
        tLevelC() {
            return this.$t('Stufe C');
        },
        tLevelD() {
            return this.$t('Stufe D');
        },
        tLevelE() {
            return this.$t('Stufe E');
        },
        tLocation() {
            return this.$t('Ort');
        },
        tExhibitionDate() {
            return this.$t('Ausstellungsdatum');
        },
        tInvalidInput() {
            return this.validInput ? '' : this.$t('club.dog.usabilityPass.invalidInput');
        },
        tCancel() {
            return this.$t('cancel');
        },
        tSaveAndClose() {
            return this.$t('saveAndClose');
        },
        validInput() {
            return this.dogUsabilityPass.location.length > 0
                && this.dogUsabilityPass.exhibitionDate
                && this.isValidDateString;
        },
        isValidDateString() {
            let regexp = new RegExp('[0-9]{2}\\.[0-9]{2}.[0-9]{4}');
            return regexp.test(this.exhibitionDate?.valueOf());
        },
    },
    methods: {
        createPass() {
            this.pending = true;
            DogUsabilityPassRepository.createByDogId(this.dogId, this.dogUsabilityPass)
                .then(() => {
                    this.$notify.success('Der Brauchbarkeitspass wurde erstellt');
                    this.$emit('created');
                    this.closeDialog();
                })
                .catch(() => this.$notify.error('Der Brauchbarkeitspass konnte nicht erstellt werden'))
                .finally(() => this.pending = false);
        },
        closeDialog() {
            this.$emit('closeDialog');
        },
    },
    created() {
        this.dogUsabilityPass.location = this.defaultLocation;
    },
}
</script>

<style scoped lang="scss">
</style>
